import { useMemo, useState } from "react";
import { useAppSelector } from "./hooks";
import { ItemData } from "types/item.api";

const useItemCalculation = (addedItems: ItemData[]) => {
  const configData = useAppSelector((state) => state.config.configData);
  const quoteDetails = useAppSelector((state) => state.quote.quoteDetails);

  const [discount, setDiscount] = useState<number>(
    Number(quoteDetails?.discount?.amount ?? 0),
  );

  console.log("Discount i get", discount);

  const [tax, setTax] = useState<number>(
    Number(quoteDetails?.vat_setting_id ?? 0),
  );

  const taxOptions = configData?.vat_settings.map((vat) => {
    return {
      label: vat.description,
      value: vat.id,
    };
  });

  const taxPercentage = useMemo(() => {
    const vat = configData?.vat_settings?.find((v: any) => v.id === tax)?.value;

    return vat ? Number(vat) : Number(quoteDetails?.vat ?? 0);
  }, [tax, configData, quoteDetails]);

  const totals = useMemo(() => {
    if (!addedItems) {
      return {
        subTotal: 0,
        marginAmount: 0,
        marginPercentage: 0,
        taxAmount: 0,
        taxPercentage,
        discountPercentage: discount,
        discountAmount: 0,
        grandTotal: 0,
      };
    }

    const subTotal = addedItems.reduce((sum, item) => {
      const qty = item.quantity || 0;
      return sum + Number(item.price) * qty;
    }, 0);

    const marginPercentage = 0;
    const marginAmount = (subTotal * marginPercentage) / 100;
    const taxAmount = ((subTotal + marginAmount) * taxPercentage) / 100;
    const discountAmount =
      ((subTotal + marginAmount + taxAmount) * discount) / 100;
    const grandTotal = subTotal + marginAmount + taxAmount - discountAmount;

    return {
      subTotal: Number(subTotal.toFixed(2)),
      marginAmount: Number(marginAmount.toFixed(2)),
      marginPercentage,
      taxAmount: Number(taxAmount.toFixed(2)),
      taxPercentage,
      discountPercentage: discount,
      discountAmount: Number(discountAmount.toFixed(2)),
      grandTotal: Number(grandTotal.toFixed(2)),
    };
  }, [addedItems, discount, taxPercentage]);

  return {
    discount,
    setDiscount,
    tax,
    setTax,
    taxPercentage,
    totals,
    taxOptions,
  };
};

export default useItemCalculation;
